import { render } from "./YearViewer.vue?vue&type=template&id=a4f69abe"
import script from "./YearViewer.vue?vue&type=script&lang=js"
export * from "./YearViewer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__